import { render, staticRenderFns } from "./red.vue?vue&type=template&id=7616b753&scoped=true&"
import script from "./red.vue?vue&type=script&lang=js&"
export * from "./red.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7616b753",
  null
  
)

export default component.exports